module.exports = __webpack_public_path__ + "img/frame (135).d1e761ea.jpg";